import mobile from './mobile';
import desktop from './desktop';

const flavors = {
  desktop,
  mobile,
};

export default flavors;
